import { Tooltip } from "antd";
import { Text } from "components/shared/text";

export const RowCaptionBlock: React.FC<{
  text: string;
  text2?: string;
  helpText?: string;
  height?: number;
  borderProp?: Record<string, string>;
}> = ({ text, text2, helpText, borderProp }) => (
  <group
    data-background="main-background"
    data-sticky="left"
    data-length="380"
    data-height="auto"
    data-min-height="50"
    data-space="5"
    data-space-horizontal="20"
    //data-align="center"
    data-justify="center"
    data-direction="column"
    {...(borderProp ? borderProp : { "data-border": "inset" })}

    //data-direction={text2 ? "column" : "row"}
  >
    <group data-align="center" data-wrap="no">
      <Text
        //data-position="left"
        data-wrap="wrap"
        data-weight="500"
      >
        {text}
      </Text>
      {helpText && (
        <Tooltip
          arrow={false}
          color="var(--accent-dark)"
          space={false}
          title={
            <group data-direction="column" data-gap="10" data-space="5">
              <Text data-weight="700" data-wrap="wrap">
                {helpText}
              </Text>
            </group>
          }
        >
          <div
            data-position="right"
            data-type="group"
            data-width="auto"
            data-space="5"
            data-interactive=""
            data-radius="30"
            data-color="grey-color-mid"
          >
            <icon data-icon-size="small">help</icon>
          </div>
        </Tooltip>
      )}
    </group>

    {text2 && (
      <Text
        data-space-left="20"
        //data-position="left"
        data-weight="500"
      >
        {text2}
      </Text>
    )}
  </group>
);
